export default __webpack_public_path__ + "static/media/8.2cc24549.jpg";